export const PERMISSIONS = {
    CONTACTS_MANAGE: "contacts.manage", // add/edit contacts

    CONTRACTS_MANAGE: "contracts.manage", // issue/re-send contracts

    ENROLMENT_MANAGE: "enrolment.manage", // edit packages/subjects for the student

    FINANCE_MANAGE: "finance.manage", // pay invoice, change payment settings

    RENEWALS_MANAGE: "renewals.manage",

    STUDENT_UPDATE: "student.manage", // update student data
    STUDENT_VIEW: "student.view", // view student

    ATTENDANCE_MANAGE: "attendance.manage", // view student
};

export function hasPermission(userPermissions, requiredPermission) {
    if (!Array.isArray(userPermissions)) return false;
    return userPermissions.includes(requiredPermission);
}
